import axios from "axios";
import { UserSession } from "../user_session";
import * as Vars from "./Vars";

export class Profile {

  /**
   * Loads all the profile information from the logged in user.
   */
  static async load(){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/profile/",
        method: "GET",
        params: {
          _console_token: UserSession.token
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  /**
   * Updates the console password of the logged in user.
   * @param {string} currentPassword The current password.
   * @param {string} newPassword The new strong password.
   */
  static async updatePassword(currentPassword, newPassword){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/profile/",
        method: "PUT",
        data: {
          _console_token: UserSession.token,
          currentPassword: currentPassword,
          newPassword: newPassword
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  /**
   * Updates some details of the logged in user.
   * @param {string} firstName The first name of the logged in user.
   * @param {string} lastName The last name of the logged in user.
   */
  static async updateDetails(firstName, lastName){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/profile/",
        method: "PUT",
        data: {
          _console_token: UserSession.token,
          firstName: firstName,
          lastName: lastName
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  /**
   * Gets the amount of active sessions.
   * @return {number}
   */
  static async getActiveSessionsAmount() {
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/profile/",
        method: "GET",
        params: {
          _console_token: UserSession.token,
          function: "sessions"
        }
      }).then(function(data){
        resolve(data.data);
      });
    })
  }
}
